var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getSpecialRateBasedOnCriterion from './convertTrimsDataToCardProps/getSpecialRateBasedOnCriterion';
import { PaymentMethod } from '../constants';
export function getEmptyOfferCategory() {
    var _a;
    var emptyList = [];
    return _a = {},
        _a[PaymentMethod.cash] = emptyList,
        _a[PaymentMethod.lease] = emptyList,
        _a[PaymentMethod.finance] = emptyList,
        _a;
}
export default function mapOffersToTrims(trims, offers) {
    var offersMap = offers.reduce(function (map, offer) {
        if (!offer.transmissionKey)
            return map;
        map.set(offer.transmissionKey, offer);
        return map;
    }, new Map());
    return trims.map(function (trim) {
        var _a, _b, _c, _d, _e;
        var trimOffer = offersMap.get(trim.transmissionKey);
        var specialRateOffers = (_a = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.specialRateOffers) !== null && _a !== void 0 ? _a : getEmptyOfferCategory();
        var specialRateCriterion = (_c = (_b = trim.defaultTransmission) === null || _b === void 0 ? void 0 : _b.specialRateCriterion) === null || _c === void 0 ? void 0 : _c.value;
        var specialRates = getSpecialRateBasedOnCriterion(specialRateOffers, specialRateCriterion || '');
        return __assign(__assign({}, trim), { specialRates: specialRates, offers: {
                specialRateOffers: specialRateOffers,
                loyaltyOffers: (_d = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.loyaltyOffers) !== null && _d !== void 0 ? _d : getEmptyOfferCategory(),
                incentiveOffers: (_e = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.incentiveOffers) !== null && _e !== void 0 ? _e : getEmptyOfferCategory(),
                bonusOffers: trim.financials.bonusOffers.reduce(function (offerGroups, offer) {
                    var _a;
                    var _b;
                    return (__assign(__assign({}, offerGroups), (_a = {}, _a[offer.paymentMethod] = (_b = offer.offers) !== null && _b !== void 0 ? _b : [], _a)));
                }, {}),
            } });
    });
}
